'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "notifications", "onRemoveNotification"];
import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import UIFloatingAlertList from 'UIComponents/alert/UIFloatingAlertList';
import { FloatingAlertList } from 'foundations-components/transitional/components/FloatingAlertList';
import { filterProps } from 'foundations-components/utils/filterProps';
import { removeNotification } from '../actions/NotificationActions';
import { jsx as _jsx } from "react/jsx-runtime";
class NotificationList extends Component {
  render() {
    const _this$props = this.props,
      {
        className,
        notifications,
        onRemoveNotification
      } = _this$props,
      restProps = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const {
      tokenProps
    } = filterProps(restProps);
    const floatingAlerts = Object.keys(notifications).map(notificationId => {
      const clonedNotification = Object.assign({}, notifications[notificationId]);
      // These properties are only used internally by ReduxMessenger,
      // and should not be passed onto the FloatingAlert component
      delete clonedNotification.sticky;
      delete clonedNotification.timeout;
      return clonedNotification;
    });

    // TODO: remove UIComponents when deprecating the className prop
    return className ? /*#__PURE__*/_jsx(UIFloatingAlertList, {
      alerts: floatingAlerts,
      className: className,
      onAlertClose: (evt, {
        id
      }) => onRemoveNotification(id)
    }) : /*#__PURE__*/_jsx(FloatingAlertList, Object.assign({}, tokenProps, {
      alerts: floatingAlerts,
      onAlertClose: (evt, {
        id
      }) => onRemoveNotification(id)
    }));
  }
}
NotificationList.propTypes = {
  'data-test-id': PropTypes.string,
  className: PropTypes.string,
  // TODO: remove after deprecating the className prop
  notifications: PropTypes.object.isRequired,
  onRemoveNotification: PropTypes.func.isRequired
};
const mapStateToProps = state => ({
  notifications: state.notifications
});
const actionCreators = {
  onRemoveNotification: removeNotification
};
export default connect(mapStateToProps, actionCreators)(NotificationList);